// Kept free of imports: `atom.ts` reads DEFAULT_KPI_IDS at module load, and
// importing it from AlertTableGrid once closed a cycle (AlertTableGrid → atom →
// AlertTableGrid) that left an atom uninitialised on a cold load.
export type kpiIdOrder = {
  order: number;
  id: number;
  columnWidth?: number;
};

export const DEFAULT_KPI_IDS = [
  1, 7, 8, 9, 13, 14, 15, 18, 19, 20, 21, 22, 31, 36, 55,
];
